import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

Vue.use(VueApollo);
const httpLink = createHttpLink({
    uri: '/api/graphql',
});

const authLink = setContext((_, { headers }) => {
    const token = Vue.prototype.$keycloak.token

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        }
    }
});

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({
        addTypename: false
    }),
    // PA-3587: con la politica por defecto ('none'), un error GraphQL en un solo campo
    // descarta TODO el 'data' de la query, dejando pantallas en blanco. Con 'all' se
    // entregan los datos validos junto a los errores. Se aplica a query/watchQuery; las
    // mutaciones conservan su comportamiento (rechazo -> .catch) sin cambios.
    defaultOptions: {
        query: { errorPolicy: 'all' },
        watchQuery: { errorPolicy: 'all' }
    }
});

export const apolloProvider = new VueApollo({
    defaultClient: client,
    errorHandler(error) {
        console.error(error)
    }
});